<template>


  <div>
    <div class="banner innerpageBanner">
      <div class="container">
        <div class="caption">
          <div><h1>五星酒款</h1>
          </div>
        </div>
      </div>

      <img src="https://image.insideburgundy.cn/insideburgundy/20190528/8dfb84a9a056438fb9c3cd8cc8ded89d.png" alt="" class="cover-image">
    </div>
    <div class="container">
      <searchBox  />
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <span property="name">五星酒评页</span>
            <meta property="position" content="2">
          </span>
        </div>
      </div>
    </div>
     <div class="container">
        <rightMenu title="分类"   :menudata='rightListdata' @OnClick='rightClick'/>
        <div class="leftCol">
          <div>
            <h2>{{this.searchValue?this.searchValue:'All'}} 5 Star Wines</h2>
            <div class="newstopBlock"></div>
          </div>

          <div class="notesYear" v-for="(item,index) in latestList" :key='index'>
            <h4>{{item.vintage}}</h4>

            <div class="notes five_star_listing" v-for="it in item.child" :key='it.id'>
              <div class="jasperStarWine">
                <span class="five_star_icon">5</span>5 Star Wine
                <a
                  :href="'#/tastingnotes?id='+it.id"
                  class="five_star_link"
                  style="background-image: none;"
                >详细信息</a>
              </div>

              <div class="noteContent">
                <div id="24453" class="noteTitle">
                  <span>{{it.title}}</span>
                  <div class="rightRating">
                    <div class="star-ratings-sprite">
                      <span class="star-ratings-sprite-rating" style="width: 100%;"></span>
                    </div>
                    <span class="score">{{it.score}}</span>
                  </div>
                </div>
                <div
                  class="noteText"
                  style="padding-bottom: 15px; margin-bottom: 0px;"
                >
                {{it.content}}
                </div>
              </div>
              <div class="galance">
                <div class="row">
                  <h6>概览</h6>
                </div>
                <div class="row">
                  <ul>
                    <li>
                      <strong>酒庄：</strong> {{it.producer}}
                    </li>
                    <li>
                      <strong>村庄：</strong> {{it.village}}
                    </li>
                    <li>
                      <strong>颜色：</strong> {{it.wineColour}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

          <div class="tablenav-pages">
            <pagination  :total='total' :pageNo="pageNo"  @pageChange="pageChange" :pageSize='15' />
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import searchBox from "../template/search";
import ajax from "../ajax";
import rightMenu from '../template/rightMenu';
import pagination from '../template/pagiation'
export default {
  data() {
    return {
      latestList: [],
      total:0,
      pageNo:0,
      rightListdata:{},
      searchValue:'',
      query:{}
    };
  },
  components: {
    searchBox,
    pagination,
    rightMenu
  },
  created() {
    this.getlatestList();
    this.getRightdata()
  },
  methods: {
    getRightdata(){
      ajax.getcategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    rightClick(data,parent){
      if(!data.child){
        this.searchValue = data;
        let query = {};
        let parentName = parent.name.toLocaleLowerCase();
        if(parentName=='年份'){
          query['vintage']= data
        }else if(parentName=='酒庄'){
          query['producer']= data
        }else if(parentName=='村庄'){
          query['village']= data
        }
        this.query = query;
        this.pageNo = 0;
        this.getlatestList()
      }

    },
    pageChange(n){
      this.pageNo = n;
      this.getlatestList()
    },
    getlatestList() {
      let query = {pageNo:this.pageNo,pageSize:15};
      query = Object.assign(query,this.query)
      ajax.getTastingNotes(query).then(res => {
        let data = [];
        res.data.data.forEach(item=>{
          if(data.length){
            if(data.filter(it=>it.vintage==item.vintage).length){
              data.forEach(it=>{
                if(it.vintage == item.vintage)
                it.child.push(item)
              })
            }else{
              data.push({
              vintage:item.vintage,
              child:[item]
            })
            }
          }else{
            data.push({
              vintage:item.vintage,
              child:[item]
            })
          }
        })
        this.latestList = data;
        this.total = res.data.total
      });
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Fivestars.vue